(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["courses-list"]) return;
  try {
    
	var arrayUnique = function (arr) {
        return arr.filter(function(item, index){
            return arr.indexOf(item) >= index;
        });
    };

	// Tab Management 
    ready(function(){ 
		
		const topicSelect = document.querySelector('#topic-filters')
		const formatSelect = document.querySelector('#format-filters')

		const params = new Proxy(new URLSearchParams(window.location.search), {
          get: (searchParams, prop) => searchParams.get(prop),
        })
        //console.log('params', params)
		if(params.formatIndex) {
			formatSelect.selectedIndex = parseInt(params.formatIndex)
			const selOption = formatSelect.options[formatSelect.selectedIndex]
			if(selOption) formatSelect.value=selOption.value
        }

		const allFormats = document.querySelector('[data-format="all"]')

		const grid = document.getElementById('courses-list')
    	const hidden = document.getElementById('courses-list-hidden')
		const products = document.querySelectorAll('#courses-list-hidden [data-product]')
		const select = function(){
			
			let topicSelected = topicSelect.options[topicSelect.selectedIndex]
			let formatSelected = formatSelect.options[formatSelect.selectedIndex]
			
			// build select options
			const formats = []
			for(let i=0;i<products.length;i++){
				let product = products[i]
				//console.log('PRODUCT', product)
                     
				if(product) {
                   	const topics = product.dataset.topics.split(',')
                	//console.log('TOPIC', topicSelected.dataset.topic, topics)
                    if(topicSelected.dataset.topic == 'all' || topics.indexOf(topicSelected.dataset.topic) >=0){
                   		const format = product.dataset.format
                        if(formats.indexOf(format) < 0) formats.push(format)
                    }
              	}
            }

			const formatOptions = document.querySelectorAll('.format-filter')
			for(let i=0;i<formatOptions.length;i++){
               	let option = formatOptions[i]
				option.classList.remove('hidden')	
				if(option.dataset.format != 'all' && formats.indexOf(option.dataset.format) < 0) {
					option.classList.add('hidden')
				}
            }
			
			// hide/show all formats based on topic selection
			if(topicSelected.dataset.topic == 'all'){
              	//allFormats.classList.remove('hidden')                                      
			}
            else{
            	//allFormats.classList.add('hidden')                                      
            }

			// reselect
			formatSelected = formatSelect.options[formatSelect.selectedIndex]
			if(formatSelected.classList.contains('hidden')){
				for(let i=0;i<formatOptions.length;i++){
 					const opt = formatOptions[i]                                                        
					if(!opt.classList.contains('hidden') ){
						console.log('OPTION INDEX', opt.index)
						formatSelect.selectedIndex = opt.index
                        formatSelected = opt
						break
					}                                                         
				}
			}

			                                             
			// render products
			grid.innerHTML = ""
			for(let i=0;i<products.length;i++){
				let product = products[i]
				if(product) {
                   	const topics = product.dataset.topics.split(',')
                   	const format = product.dataset.format
					
                   	if((!topicSelected || topicSelected.dataset.topic == "all" || topics.indexOf(topicSelected.dataset.topic) >= 0) && 
                       (!formatSelected || formatSelected.dataset.format == "all" || formatSelected.dataset.format == format)){
                    	//console.log('product values', topics, format, i, formatSelected.dataset.format)
            		    grid.appendChild(product)
                   	}
				}
            }
		}

		topicSelect.onchange = select
		formatSelect.onchange = select
		formatSelect.dispatchEvent(new Event('change'))
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topic-courses"]) return;
  try {
    

	// Tab Management 
    ready(function(){ 
		
		const select = document.querySelector('#topic-filters')

		const grid = document.getElementById('topic-products')
    	const hidden = document.getElementById('topic-products-hidden')
		const products = document.querySelectorAll('[data-product]')

		select.onchange = function(){
			const selected = select.options[select.selectedIndex]
			grid.innerHTML = ""
			for(let i=0;i<products.length;i++){
				let product = products[i]
				if(product) {
                   	const type = product.dataset.product
                   	if(selected.dataset.topic == "all" || selected.dataset.topic == type){
                        grid.appendChild(product)
                   	}
				}
            }
		}
		select.dispatchEvent(new Event('change'))
    })

  } catch(e) { console.error(e); }
})();
})();
